// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1ke5a","title":"ClientReferral_title__3Lilk","itemText":"ClientReferral_itemText__MQMyK"};